module.exports = "/076c958321237351e457a25f1551005dcff1e8fc/475396997e3882d510b3437585c5014b.svg";